import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class I18nService {
	public readonly strings: { [key: string]: string } = {};

	constructor() {}

	/**
	 * get the translated string, or return none-translated fallback string
	 * @fallback => just in case there is no alternative translation
	 * @key => key for the translated string (needs to appear in `i18n/_strings/i18n-strings-here.html`)
	 */
	public get(fallback: string, id: string): string {
		if (!this.strings || !this.strings[id]) {
			return fallback;
		}
		return this.strings[id];
	}

	public set(source: string, id: string): void {
		this.strings[id] = source;
	}
}
